export type PhotoStateSource =
  | {
      photos?: string[];
      downloadedImage?: string[];
    }
  | null
  | undefined;

export type BuildUploadedPhotoStateParams = {
  photos: string[];
  downloadedImage: string[];
  filePath: string;
  fallbackPreviewURL: string;
  photoIndex?: number;
  resolveDownloadURL: (filePath: string) => Promise<string>;
};

export type BuildUploadedPhotoStateResult = {
  photos: string[];
  downloadedImage: string[];
  resolveError?: Error;
};

export function clonePhotoStateArrays(source: PhotoStateSource): {
  photos: string[];
  downloadedImage: string[];
} {
  const photos = Array.isArray(source?.photos) ? source!.photos.slice() : [];
  const downloadedImage = Array.isArray(source?.downloadedImage) ? source!.downloadedImage.slice(0, photos.length) : [];

  while (downloadedImage.length < photos.length) {
    downloadedImage.push('');
  }

  return {
    photos,
    downloadedImage
  };
}

export async function buildUploadedPhotoState({
  photos,
  downloadedImage,
  filePath,
  fallbackPreviewURL,
  photoIndex,
  resolveDownloadURL
}: BuildUploadedPhotoStateParams): Promise<BuildUploadedPhotoStateResult> {
  let previewURL = fallbackPreviewURL;
  let resolveError: Error | undefined;

  try {
    previewURL = await resolveDownloadURL(filePath);
  } catch (error) {
    resolveError = error instanceof Error ? error : new Error(String(error));
  }

  const nextPhotos = photos.slice();
  const nextDownloadedImage = downloadedImage.slice();

  if (photoIndex === null || photoIndex === undefined) {
    nextPhotos.push(filePath);
    nextDownloadedImage.push(previewURL);
  } else {
    nextPhotos[photoIndex] = filePath;
    nextDownloadedImage[photoIndex] = previewURL;
  }

  return {
    photos: nextPhotos,
    downloadedImage: nextDownloadedImage,
    resolveError
  };
}

export default buildUploadedPhotoState;
